export default __webpack_public_path__ + "media/images/user_photos/141-a5228fd05015bb8bfb00892dd24e0701.jpg";